import { Instance, SnapshotIn, types } from 'mobx-state-tree';

// import AlbumModel from './AlbumModel';

const TrackModel = types.model('TrackModel', {
    id: types.identifier,
    name: types.string,
    uri: types.string,
    duration: types.number,
    artists: types.string,
    imageUrl: types.string,
    // album: types.safeReference(AlbumModel, { acceptsUndefined: false }),
});

export interface ITrackModel extends Instance<typeof TrackModel> {}
export interface ITrackModelSnapshotIn extends SnapshotIn<typeof TrackModel> {}

export default TrackModel;
